import { buildIPPMedium } from '@shared-utils/helpers/tracking';
import { AV_LINK_TEXT } from '@shared-utils/types/analytics.types';
import { Context } from '@shared-utils/types/common.types';
export const context = Context.PRICE_MAP;
export const GERMAN_PROFILE_ANCHOR = '#kontakt';
const mediumLogo = buildIPPMedium(context, AV_LINK_TEXT.LOGO);
const mediumContact = buildIPPMedium(context, AV_LINK_TEXT.CONTACT_CTA);
const mediumName = buildIPPMedium(context, AV_LINK_TEXT.NAME);
export const mediums = { mediumContact, mediumLogo, mediumName };
